import { render, staticRenderFns } from "./NhlPlayerTrends.vue?vue&type=template&id=04871bd1&scoped=true"
import script from "./NhlPlayerTrends.vue?vue&type=script&lang=js"
export * from "./NhlPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04871bd1",
  null
  
)

export default component.exports